import FAQBox from './FAQBox.jsx';
import FAQList from './FAQList.jsx';
import FAQForm from './FAQForm.jsx';

export {FAQBox, FAQList, FAQForm};



// WEBPACK FOOTER //
// ./components/faq/index.js